/*
 * "Can't find it? Tell us" box (snippets/mist-stock-request.liquid).
 * The form posts to a Google Form through a hidden iframe; this fills the source from ?src= and the box from ?q=,
 * drops bot submissions (honeypot filled) and swaps the form for the thank-you line once sent.
 */
(() => {
  const params = new URLSearchParams(window.location.search);
  const src = params.get('src');
  const term = params.get('q');
  document.querySelectorAll('[data-mist-ask]').forEach((box) => {
    const source = box.querySelector('[data-mist-ask-source]');
    if (source && !source.value) source.value = (src || 'page').slice(0, 60);
    const input = box.querySelector('textarea');
    if (term && input && !input.value) input.value = term.slice(0, 200);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-mist-ask-form]');
    if (!form) return;
    if (form.querySelector('.mist-ask__hp')?.value) {
      event.preventDefault();
      return;
    }
    const box = form.closest('[data-mist-ask]');
    const frame = box.querySelector('iframe');
    frame.addEventListener(
      'load',
      () => {
        form.hidden = true;
        box.querySelector('.mist-ask__thanks').hidden = false;
      },
      { once: true }
    );
    form.querySelector('button[type="submit"]')?.setAttribute('aria-busy', 'true');
  });
})();
